import api from "@/services/api";

const API_URL = '/dashboard';

const _http = {
  getSummary() {
    return api.get(API_URL);
  }
};


export default {
  async getSummary() {
    const res = await _http.getSummary();

    return res.data.data;
  },
};
